import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { formatImage } from '@ifeng-fe/three_terminal/es/base/publicMethod/formatImage';
import styles from './index.css';
import defaultAvatar from '../../assets/defaultAvatar.png';

const cx = classNames.bind(styles);

/**
 *
 * @param {String} [size=normal] - 头像尺寸
 * @param {String} link - 头像地址
 * @param {String} [shape=circle] - shape 头像形状
 * @returns
 */
const Avatar = ({ size = 'normal', link, shape = 'circle' }) => {
    const getAvatarSize = size => {
        switch (size) {
            case 'large':
                return [88, 88];
            case 'normal':
                return [64, 64];
            case 'small':
                return [48, 48];
            default:
                return [64, 64];
        }
    };

    return (
        <div className={cx('avatar', size, shape)}>
            <img src={link ? formatImage(link, ...getAvatarSize(size)) : defaultAvatar} alt="" />
        </div>
    );
};

Avatar.propTypes = {
    /**
     * 可选值为’large'=88x88|'normal'=64x64|'small'='48x48', 'unset'="100% * 100%"
     */
    size: PropTypes.string,
    /**
     * 头像照片地址
     */
    link: PropTypes.string,
    /**
     * 头像展示形状，默认为circle，可以选择square，方形
     */
    shape: PropTypes.string,
};

export default Avatar;
